import get from "lodash.get"

import { VehicleDetailsResponse } from "../../api/endpoints/vehicleDetails/types"
import { VehicleDetailsWithImage } from "../../api/endpoints/vehicleDetailsWithImage/types"

export const selectVehicleDetails = (
  vehicleDetails: VehicleDetailsResponse | any
) => {
  if (!vehicleDetails || !(vehicleDetails as any).requestResultsType) {
    return {}
  }

  const defaultCapImageUrl =
    (vehicleDetails as VehicleDetailsWithImage.RootObject).defaultCapImageUrl ||
    ""

  const { vin, vrm } = get(
    vehicleDetails,
    "requestResultsType.asset.assetIdentification",
    {}
  )
  const { capCode, capId, vehicleType } = get(
    vehicleDetails,
    "requestResultsType.asset.supplementaryAssetData.cap",
    {}
  )
  const {
    make,
    model,
    body = {},
    engine,
    keyDates: {
      firstRegistered: { date: dateRegistered = "" } = {},
      manufactured: { year = "" } = {},
    } = {},
    keepers: { totalPreviousKeepers = "" } = {},
  } = get(vehicleDetails, "requestResultsType.asset.primaryAssetData.dvla", {})

  const { transmission } = get(
    vehicleDetails,
    "requestResultsType.asset.primaryAssetData.smmt",
    {}
  )

  const {
    colour,
    wheelPlan,
    doors = "",
    description,
  } = body

  const makeDescription = make ? make?.description : ""
  const modelDescription = model ? model?.description : ""
  const previousOwners = totalPreviousKeepers
    ? `${totalPreviousKeepers} previous owners`
    : ""
  const bodyDescription = description ? description : ""
  const wheels = wheelPlan ? wheelPlan?.description : ""
  const vehicleTransmission = transmission ? transmission?.description : ""
  const vehicleColour = colour ? colour?.current.description : ""
  const numberOfDoors = doors ? `${doors} doors` : ""

  return {
    vin,
    vrm,
    capId,
    capCode,
    vehicleType,
    make: makeDescription,
    model: modelDescription,
    makeAndModel: `${makeDescription} ${modelDescription}`,
    engine: engine ? engine?.size : "",
    derivative: `${year} ${bodyDescription} ${vehicleColour}`,
    previousOwners: previousOwners,
    additionalFeatures: [
      vehicleTransmission,
      wheels,
      numberOfDoors
    ],
    dateRegistered,
    defaultCapImageUrl: defaultCapImageUrl,
  }
}
